import React, { useState, useEffect } from 'react';
import { piApi } from '../../../services/piApi';
import '../PIShell.css';

export default function PIOverviewTab({ portco, currentUser }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    piApi.getPortcoStats(portco.id).then(r => setStats(r.data)).catch(() => {});
  }, [portco.id]);

  return (
    <div style={{ padding: '28px 32px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        {[
          { label: 'Entry EBITDA', value: portco.entry_ebitda != null ? `$${portco.entry_ebitda}M` : '—' },
          { label: 'Underwritten Revenue', value: portco.underwritten_revenue != null ? `$${portco.underwritten_revenue}M` : '—' },
          { label: 'Target IRR', value: portco.target_irr != null ? `${portco.target_irr}%` : '—' },
          { label: 'Target MOIC', value: portco.target_moic != null ? `${portco.target_moic}x` : '—' },
        ].map(s => (
          <div key={s.label} className="pi-stat-card">
            <div className="pi-stat-value">{s.value}</div>
            <div className="pi-stat-label">{s.label}</div>
          </div>
        ))}
      </div>
      {stats && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          {[
            { label: 'VCP Initiatives', value: stats.initiativeCount ?? 0 },
            { label: 'Initiatives Done', value: stats.initiativesDone ?? 0 },
            { label: 'Bridge Variance', value: stats.bridgeVariancePct != null ? `${stats.bridgeVariancePct}%` : '—' },
          ].map(s => (
            <div key={s.label} className="pi-stat-card">
              <div className="pi-stat-value">{s.value}</div>
              <div className="pi-stat-label">{s.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
